// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simplestream .playnext-container {
    position: absolute; 
    bottom: 20%; 
    right: 0px; 
    width: 400px; 
    height: 80px;
    display: flex; 
    align-items: center;
    z-index: 1000;
    color: white;
    background: black;
    display: none;
    cursor: pointer;
}
.simplestream .playnext-container .playnext-text {
    padding-left: 10px;
    padding-right: 5px;
}
.simplestream .playnext-container .playnext-text .playnext-text-title {
    font-weight: bold;
    margin-bottom: 0px;
}
.simplestream .playnext-container .playnext-text .playnext-text-subtitle {
    color: rgb(155 155 155);
    margin-bottom: 0px;
}
.simplestream .playnext-container .playnext-image {
    position: relative;
}
.simplestream .playnext-container .playnext-image img {
    width: 142px;
    height: 80px;
    opacity: 0.8;
}
.simplestream .playnext-container .playnext-image .playnext-countdown {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 142px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
}
#countdown {
    height: 60px;
    width: 60px;
}

/* base timer */
.base-timer {
    position: relative;
    width: 60px;
    height: 60px;
}
.base-timer__svg {
    transform: scaleX(-1);
}
.base-timer__circle {
    fill: none;
    stroke: none;
}
.base-timer__path-elapsed {
    stroke-width: 7px;
    stroke: grey;
}
.base-timer__path-remaining {
    stroke-width: 7px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    fill-rule: nonzero;
    stroke: currentColor;
}
.base-timer__path-remaining.green {
    color: rgb(65, 184, 131);
}
.base-timer__path-remaining.orange {
    color: orange;
}
.base-timer__path-remaining.red {
    color: red;
}
.base-timer__path-remaining.white {
    color: white;
}
.base-timer__label {
    position: absolute;
    width: 60px;
    height: 60px;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/playnext/PlayNextPlugin.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,wBAAwB;IACxB,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB","sourcesContent":[".simplestream .playnext-container {\n    position: absolute; \n    bottom: 20%; \n    right: 0px; \n    width: 400px; \n    height: 80px;\n    display: flex; \n    align-items: center;\n    z-index: 1000;\n    color: white;\n    background: black;\n    display: none;\n    cursor: pointer;\n}\n.simplestream .playnext-container .playnext-text {\n    padding-left: 10px;\n    padding-right: 5px;\n}\n.simplestream .playnext-container .playnext-text .playnext-text-title {\n    font-weight: bold;\n    margin-bottom: 0px;\n}\n.simplestream .playnext-container .playnext-text .playnext-text-subtitle {\n    color: rgb(155 155 155);\n    margin-bottom: 0px;\n}\n.simplestream .playnext-container .playnext-image {\n    position: relative;\n}\n.simplestream .playnext-container .playnext-image img {\n    width: 142px;\n    height: 80px;\n    opacity: 0.8;\n}\n.simplestream .playnext-container .playnext-image .playnext-countdown {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 142px;\n    height: 80px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n#countdown {\n    height: 60px;\n    width: 60px;\n}\n\n/* base timer */\n.base-timer {\n    position: relative;\n    width: 60px;\n    height: 60px;\n}\n.base-timer__svg {\n    transform: scaleX(-1);\n}\n.base-timer__circle {\n    fill: none;\n    stroke: none;\n}\n.base-timer__path-elapsed {\n    stroke-width: 7px;\n    stroke: grey;\n}\n.base-timer__path-remaining {\n    stroke-width: 7px;\n    stroke-linecap: round;\n    transform: rotate(90deg);\n    transform-origin: center;\n    transition: 1s linear all;\n    fill-rule: nonzero;\n    stroke: currentColor;\n}\n.base-timer__path-remaining.green {\n    color: rgb(65, 184, 131);\n}\n.base-timer__path-remaining.orange {\n    color: orange;\n}\n.base-timer__path-remaining.red {\n    color: red;\n}\n.base-timer__path-remaining.white {\n    color: white;\n}\n.base-timer__label {\n    position: absolute;\n    width: 60px;\n    height: 60px;\n    top: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
